import {
  PatchedRepeatingEventUpdateRequest,
  SeriesRequest,
  partialUpdateRepeatingEvent,
  partialUpdateSeries
} from '@goldcast/api/backend';

const actions = {
  updateSeriesById({ commit }, { seriesId, payload }: { seriesId: string; payload: SeriesRequest }) {
    commit('setIsUpdatingSeries', true);

    const seriesPayload: SeriesRequest = {
      ...payload
    };

    return partialUpdateSeries({
      id: seriesId,
      body: seriesPayload,
      queryParams: {
        get_tags: true
      }
    })
      .then(updatedSeries => {
        commit('studioSeriesList/updateCurrentSeries', { seriesId, series: updatedSeries }, { root: true });
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        commit('setIsUpdatingSeries', false);
      });
  },
  updateRepeatingEventById(
    { commit, rootState },
    { seriesId, payload }: { seriesId: string; payload: PatchedRepeatingEventUpdateRequest }
  ) {
    const eventId = rootState.studioEventList.currentEventId;

    commit('setIsUpdatingSeries', true);

    return partialUpdateRepeatingEvent({ id: seriesId, body: payload })
      .then(updatedSeries => {
        commit('studioSeriesList/updateCurrentSeries', { seriesId, series: updatedSeries }, { root: true });
        if (payload.event_fields) {
          commit('studioEventList/partialUpdateEvent', { eventId, partialEvent: payload.event_fields }, { root: true });
        }
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        commit('setIsUpdatingSeries', false);
      });
  }
};

export default actions;
